// because we serve our static files with nginx, everything in process.env is baked in at
// build time and never replaced, so we want to replace most of it with data injected via window.ENV.
//
// Certain params, like REACT_APP_VERSION, are baked in at build time and will not be overwritten.
//
// Note, for running dev, 'npm start' will replace process.env with the local '.env' file
export const env = {
  ...process.env,
  ...window.ENV
};

let domain = `${env.REACT_APP_ENV}.ltnportal.com`;
let zendeskHost = 'https://ltnglobal1777564739.zendesk.com';

if (env.REACT_APP_ENV === 'prod') {
  domain = 'www.ltnportal.com';
  zendeskHost = 'https://ltnglobal.zendesk.com';
} else if (env.REACT_APP_ENV === 'local' || env.REACT_APP_ENV === 'dev') {
  domain = '';
}

export const DOMAIN = domain;
export const ZENDESK_HOST = zendeskHost;
